// extracted by mini-css-extract-plugin
export default {"toggle":"toggle_toggle__bi00k","toggle__slider":"toggle_toggle__slider__Y7jmz"};